import {invalidateOnSuccess, omneticApi} from '@dms/api/base';

import {
  CreateConfidentialOAuthClientApiArg,
  CreateConfidentialOAuthClientApiResponse,
  CreatePublicOAuthClientApiArg,
  CreatePublicOAuthClientApiResponse,
  DeleteOAuthClientApiArg,
  DeleteOAuthClientApiResponse,
  GetOAuthClientApiArg,
  GetOAuthClientApiResponse,
  RegenerateOAuthClientSecretApiArg,
  RegenerateOAuthClientSecretApiResponse,
  UpdateOAuthClientApiArg,
  UpdateOAuthClientApiResponse,
} from './types';

export const oauthClientApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getOAuthClient: build.query<GetOAuthClientApiResponse, GetOAuthClientApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/auth/oauth/client/${queryArg.oauthClientId}`,
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'OAuthClient', id: queryArg.oauthClientId},
      ],
    }),
    createPublicOAuthClient: build.mutation<
      CreatePublicOAuthClientApiResponse,
      CreatePublicOAuthClientApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/auth/oauth/public-client`,
        method: 'POST',
        body: queryArg.createPublicOAuthClientRequestBody,
      }),
    }),
    createConfidentialOAuthClient: build.mutation<
      CreateConfidentialOAuthClientApiResponse,
      CreateConfidentialOAuthClientApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/auth/oauth/confidential-client`,
        method: 'POST',
        body: queryArg.createConfidentialOAuthClientRequestBody,
      }),
    }),
    updateOAuthClient: build.mutation<UpdateOAuthClientApiResponse, UpdateOAuthClientApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/auth/oauth/client/${queryArg.oauthClientId}`,
        method: 'PUT',
        body: queryArg.updateOAuthClientRequestBody,
      }),
      invalidatesTags: invalidateOnSuccess((_result, queryArg: UpdateOAuthClientApiArg) => [
        {type: 'OAuthClient', id: queryArg.oauthClientId},
      ]),
    }),
    deleteOAuthClient: build.mutation<DeleteOAuthClientApiResponse, DeleteOAuthClientApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/auth/oauth/client/${queryArg.oauthClientId}`,
        method: 'DELETE',
      }),
      invalidatesTags: invalidateOnSuccess((_result, queryArg: DeleteOAuthClientApiArg) => [
        {type: 'OAuthClient', id: queryArg.oauthClientId},
      ]),
    }),
    regenerateOAuthClientSecret: build.mutation<
      RegenerateOAuthClientSecretApiResponse,
      RegenerateOAuthClientSecretApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/auth/oauth/client/${queryArg.oauthClientId}/secret`,
        method: 'PUT',
        body: queryArg.regenerateOAuthClientSecretRequestBody,
      }),
      invalidatesTags: invalidateOnSuccess(
        (_result, queryArg: RegenerateOAuthClientSecretApiArg) => [
          {type: 'OAuthClient', id: queryArg.oauthClientId},
        ]
      ),
    }),
  }),
});

export const {
  useGetOAuthClientQuery,
  useCreatePublicOAuthClientMutation,
  useCreateConfidentialOAuthClientMutation,
  useUpdateOAuthClientMutation,
  useDeleteOAuthClientMutation,
  useRegenerateOAuthClientSecretMutation,
} = oauthClientApi;
